import { BlogPostMeta } from "@/data/blogPosts";

/**
 * World-Class Blog Intelligence Engine
 * Specialized for high-scale static data management (2k+ items)
 */
export class BlogService {
  /**
   * Optimized search for related articles using a single-pass filter
   * Complexity: O(n) where n is ALL_POSTS length
   */
  static getRelatedArticles(
    allPosts: BlogPostMeta[],
    currentCategory: string,
    currentHref: string,
    limit: number = 6
  ) {
    const related: { title: string; href: string }[] = [];
    
    for (let i = 0; i < allPosts.length; i++) {
      const post = allPosts[i];
      if (post.category === currentCategory && post.href !== currentHref) {
        related.push({ title: post.title, href: post.href });
        if (related.length >= limit) break;
      }
    }
    
    return related;
  }

  /**
   * Extract unique categories with cached counts for filtering UI
   */
  static getCategoriesWithCounts(allPosts: BlogPostMeta[]) {
    const counts: Record<string, number> = {};
    allPosts.forEach(post => {
      counts[post.category] = (counts[post.category] || 0) + 1;
    });
    return counts;
  }
}
